import kebabCase from 'lodash/kebabCase';
import React from 'react';
import componentProps from '../../../helpers/componentProps';
import { applyComponentTheme } from '../../../theme';
import { Grid, GridItem } from '../../Grid';
import InnerAccordionSection from '../InnerAccordionSection';
import { accordionWidthInColumns } from '../layout';
import { AccordionProps } from '../types';

const SecondaryAccordion: React.FC<AccordionProps> = ({
  accordionEntries,
  initiallyDisplayEntries,
  forceOpenForPrint,
  ...props
}) => (
  <Grid {...componentProps(props)}>
    <GridItem {...accordionWidthInColumns}>
      {accordionEntries.map((entry, index) => {
        const sectionId = `accordion-section_${kebabCase(entry.title)}`;
        const sectionEntryId = `accordion-section_entry_${kebabCase(
          entry.title
        )}_${index}`;
        return (
          <InnerAccordionSection
            sectionId={sectionId}
            entryId={sectionEntryId}
            title={entry.title}
            key={entry.title}
            initiallyDisplayEntry={entry.initiallyDisplay ?? initiallyDisplayEntries}
            forceOpenForPrint
            onExpand={entry.onExpand}
            onCollapse={entry.onCollapse}>
            {entry.content}
          </InnerAccordionSection>
        );
      })}
    </GridItem>
  </Grid>
);

export default applyComponentTheme(SecondaryAccordion, 'SecondaryAccordion');
